import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './informes.css';
import { informes} from '../../json/informes'
const Informes = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Informes</h3>
                <hr className='hr-gob'/>
            </div>
                {
                informes.map((item, index)=>(
                    <div key={ index } className='col-md-6 col-sm-6 col-6'>
                        <div className='card_container_historicos'>
                            <div className='card_anio'>
                                <h5>{ item.titulo }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="_blank">.pdf</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
        </div>
    </div>
  )
}

export default Informes